module.exports = __webpack_public_path__ + "static/Windows-bakgrunnur-1bdaf711d9007dbd0e680d163825a15e.jpg";